<template>
  <div>
    <b-modal ref="modal" :title="'Lançar Estoque'" header-class="border-bottom-0">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <!-- <select-input v-model="form.account.value" :alias="form.account.alias" :options="form.account.options" /> -->
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-12">Venda #{{ order.number }}</div>
        </div>
        <br />
      </div>

      <div slot="modal-footer">
        <button role="button" class="btn btn-outline-secondary" @click="$refs.modal.hide()">
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button role="button" class="btn btn-success" style="margin-left:5px" @click="store">
          <i class="fas fa-check"></i> Lançar Estoque
        </button>
      </div>

      <error-handler :error="error" />
      <b-alert
        :show="alertData.isVisible"
        fade
        variant="danger"
        @dismissed="alertData.isVisible = false"
        dismissible
      >{{ alertData.message }}</b-alert>
    </b-modal>
  </div>
</template>

<script>
import Filters from "./../../mixins/Filters.js";
import Form from "./../../mixins/Form.js";

export default {
  data: function() {
    return {
      order: [],

      error: null,

      alertData: {
        isVisible: false,
        message: null
      },

      form: new Form({
        order_id: {}
      })
    };
  },
  methods: {
    open(id) {
      this.form.order_id.value = id;
      this.$refs.modal.show();
    },

    store() {
      if (this.form.isValid()) {
        this.$store.commit("showLoading");
        axios
          .post("api/orderstock/store/" + this.form.order_id.value)
          .then(response => {
            this.$store.commit("hideLoading");

            this.$refs.modal.hide();

            this.$emit("stored");
          })
          .catch(error => {
            this.$store.commit("hideLoading");

            this.error = error;
          });
      } else {
        this.alertData.message = this.form.getFirstErrorMsg();

        this.alertData.isVisible = true;
      }
    },

    resetForm() {
      this.error = null;

      this.alertData.isVisible = false;

      this.form.reset();
    }
  }
};
</script>

<style>
</style>
